class AmenityMap {
	/**
	 * Initialize Amenity map
	 * @param  {[JSON]} {primary_exists: :bool, icon: url:string}    
	 * @param  {[JSON]} {map_options: {map options object (see google)}, map_styles: {map styles object (see google)}}
	 * @param  {[JSON]} {infobox_styles: {infobox styles object}}
	 * @param  {Function} {pass in callback function to call after code runs}
	 * @return {[type]}                    [description]
	 */
	constructor(amenity_map_settings={}, map_settings={}, infobox_settings={}, callback=null) {
		// highest level
		this.settings = {};
		this.google_map = null;

		// this.activeView = 'list-view';
		this.activeView = 'list-view';

		this.infobox = null;
		this.is_infobox_open = false;

		this.map_markers = [];
		this.localized_variables = AM_LOCALIZED;

		// blocks
		this.categories = $('.am-categories');
		this.active_marker = {};
		this.previous_marker = {};

		// dump localized variables into constructor settings
		amenity_map_settings = {'primary_location': JSON.parse(this.localized_variables['primary_location']), 'active_icon': this.localized_variables['active_icon']};
		map_settings = JSON.parse(this.localized_variables.map_styles);

		let parsed_infobox_settings = JSON.parse(this.localized_variables['infobox_settings']);
		infobox_settings = {'style': parsed_infobox_settings.infobox_style, 'address': parsed_infobox_settings.address, 'phone': parsed_infobox_settings.phone, 'website': parsed_infobox_settings.website};
		
		// amenity related variables
		this.category = 'all';
		// this.keyWordSearch = false;
		this.keyWordSearch = false;
		this.amenities = [];
		this.filteredAmenities = [];
		this.markers = [];

		this.isMobile = $(window).outerWidth() <= 991 ? true : false;

		// construct default options 
		
		this.toggleViews();

		// attach click handler
		this.handle_category_click();

		// populate amenities
		this.filter_categories();
		this.handleSearch();
		this.defaults(amenity_map_settings, map_settings, infobox_settings, callback);
		if( 'list-view' == this.activeView ) {
			this.setListViewMarkup(this.amenities);
		}
		else {
			this.build_amenity_map(this.amenities);
		}

		this.handle_amenity_anchor();

		if( this.isMobile ) {
			$(".am-categories__category--count-1 a").trigger('click');
		}

	}

	toggleViews() {
		var self = this;

		$(".whats-here__nav-item--list a").on('click', function(e){
			e.preventDefault();

			self.activeView = 'list-view';
			$('.whats-here__nav-item').removeClass('whats-here__nav-item--active');
			$(this).closest('.whats-here__nav-item').addClass('whats-here__nav-item--active').siblings('whats-here__nav-item--active');
			$(".amenity-map__views").removeClass('amenity-map__views--active-map').addClass('amenity-map__views--active-list');
			self.setListViewMarkup(self.amenities);
		});

		$(".whats-here__nav-item--map a").on('click', function(e){
			e.preventDefault();

			self.activeView = 'map-view';
			$('.whats-here__nav-item').removeClass('whats-here__nav-item--active');
			$(this).closest('.whats-here__nav-item').addClass('whats-here__nav-item--active').siblings('whats-here__nav-item--active');
			$(".amenity-map__views").removeClass('amenity-map__views--active-list').addClass('amenity-map__views--active-map');
			self.build_amenity_map(self.amenities);
		});
	}

	handle_amenity_anchor(){

		let target = $(window.location.hash);

		if(target.length > 0){
			target.find('a').trigger('click');
		}
	}

	handleSearch() {
		var self = this;

		var $list = $(".amenity-map__text-list");

		if( self.isMobile ) {
			// initiate search
			$(".js-search-input").on('focus', function(){
				$list.addClass('amenity-map__text-list--start-search');
				setTimeout(function(){
					$(".am-categories__category--count-0 a").trigger('click');
				}, 400);
					
			});
			$(".js-search-input").on('blur', function(){
				if( $(this).val().length < 1 ) {
					$list.removeClass('amenity-map__text-list--start-search');
				}
			});
		}	

		$(".js-search-input").on( 'change keyup', function(e){

			self.keyWordSearch = $(this).val();
			this.keyWordSearch = 'Capital Developments';
			var keyWordSearch = self.keyWordSearch.toLowerCase().replace(' ', '');
			var amenities = self.localized_variables['data']['posts'];
			$list.removeClass('amenity-map__text-list--start-search');


			if( self.keyWordSearch != "" ) {
				this.category = false;
				var filteredCategories = [];
				var filteredList = amenities.filter(function (el) {
				  return el.post_title.toLowerCase().replace(' ', '').includes(keyWordSearch);
				});

				self.setListViewMarkup( filteredList );

			}
			else {
				self.setListViewMarkup(self.localized_variables['data']['posts']);
			}
			return false;
		});
		

	}

	setListViewMarkup( amenities ) {
		var markup = ``;
		if( 'all' == this.category ) {
			for(var i in amenities) {
				markup += `<li class="amenity-map__text-item"><a href="${amenities[i].guid}" class="amenity-map__text-link" data-amenity-id="${amenities[i].ID}">${amenities[i].post_title }</a></li>`;
			}
		}
		else {
			for(var c in amenities[0].childTerms ) {
				markup += `<li class="amenity-map__text-item amenity-map__text-item--parent">
				<div id="term-link-${amenities[0].childTerms[c].term_id }" class="amenity-map__text-item-parent-link"><h5>${amenities[0].childTerms[c].name }</h5></div>
				<div class="bjzm-accordion__button bjzm-accordion__button--amenity-parent cursor-grow"><div class="bjzm-accordion__button--vertical button-line"></div><div class="bjzm-accordion__button--horiz button-line"></div></div>
				<ul class="amenity-map__sub-list">`;
				for(var i in amenities[0].childTerms[c].amenities ) {
					var amenity = amenities[0].childTerms[c].amenities[i];
					markup += `<li class="amenity-map__text-item"><a href="${amenity.guid}" class="amenity-map__text-link" data-amenity-id="${amenity.ID}">${amenity.post_title }</a></li>`;
				}

				markup +=`</ul></li>`;
			}
		}

		$(".amenity-map__text-list").html(markup);

		this.listClickEvents();

	}

	listClickEvents() {
		var self = this;
		if( !self.isMobile ) {
			$(".amenity-map__text-link").on('click', function(e){
				e.preventDefault();
				$('.amenity-map__text-item').removeClass('amenity-map__text-item--active');
				$(this).closest('.amenity-map__text-item').addClass('amenity-map__text-item--active');
				var id = $(this).data('amenity-id');
				self.setActiveAmenity(id);
			});
		}else {
			$(".amenity-map__text-item-parent-link").on('click', function(e){
				var $parent = $(this).closest('.amenity-map__text-item--parent');
				if( !$parent.hasClass('amenity-map__text-item--active-parent') ) {
					$parent.addClass('amenity-map__text-item--active-parent active').siblings().removeClass('amenity-map__text-item--active-parent active');
				}
				else {
					$parent.removeClass('amenity-map__text-item--active-parent active');
				}
				var idName = $(this).attr('id');
				setTimeout(function(){
					
					if( $("#" + idName ).offset().top - $(window).scrollTop() < 80 ) {
						
						$('html, body').animate({
							scrollTop: $("#" + idName ).offset().top - 80
						}, 400);
					}
				}, 800);
			});
		}

	}

	setActiveAmenity(amenity_id) {
		var amenities = this.localized_variables['data']['posts'];

		var filteredList = amenities.filter(function (el) {
		  return el.ID == amenity_id
		});

		this.activeAmenity = filteredList[0];

		this.setActiveAmenityMarkup();
	}

	setActiveAmenityMarkup() {
		$(".js-am").addClass('hide');

		var title = this.activeAmenity.post_title;
		var amenity_category_name = this.activeAmenity.amenity_category_name;
		var term_featured_image = this.activeAmenity.term_featured_image;
		var post_featured_image = this.activeAmenity.post_featured_image;
		var address_displayed = this.activeAmenity.address_displayed;
		var website_url = this.activeAmenity.website_url;
		var website_domain = this.activeAmenity.website_domain;
		var instagram_url = this.activeAmenity.instagram_url;
		var facebook_url = this.activeAmenity.facebook_url;
		var twitter_url = this.activeAmenity.twitter_url;
		var amenity_permalink = this.activeAmenity.amenity_permalink;

		$(".js-am-title").html(title).removeClass('hide');
		$(".js-am-category").html(amenity_category_name).removeClass('hide');

		if( address_displayed ) {
			$(".js-am-address").removeClass('hide').html( address_displayed ).removeClass('hide');
		}
		if( website_url ) {
			$(".js-am-url").removeClass('hide').find('a').html( website_domain );
			$(".js-am-url").removeClass('hide').find('a').attr('href', website_url);
		}
		if( instagram_url ) {
			$(".js-am-instagram").removeClass('hide').find('a').attr('href', instagram_url);
		}
		if( facebook_url ) {
			$(".js-am-facebook").removeClass('hide').find('a').attr('href', facebook_url);
		}
		if( twitter_url ) {
			$(".js-am-twitter").removeClass('hide').find('a').attr('href', twitter_url);
		}

		$(".js-am-permalink").removeClass('hide').find('a').attr('href', this.activeAmenity.amenity_permalink);

		$(".js-am-featured-image").removeClass('hide');

		if ( post_featured_image ){
			$(".js-am-featured-image").removeClass('hide').find('img').attr( 'src', post_featured_image );		
		} else if ( term_featured_image ) {
			$(".js-am-featured-image").removeClass('hide').find('img').attr( 'src', term_featured_image.sizes['homepage-featured-post-image'] );
		}else {
			$(".js-am-featured-image").find('img').attr('src', '');
		}

	}

	/**
	 * Get category from user click.  
	 */
	handle_category_click() {
		let _this = this;

		let $amenityMapList = $('.amenity-map__list');

		_this.categories.find('a').on('click', function(e){
			e.preventDefault();

			let same_link = false;

			if (_this.category == $(this).data('term-slug')) {
				same_link = true;
			}
			_this.category = ($(this).parent().hasClass('am-categories--active')) ? _this.category : $(this).data('term-slug');

			// add and remove active classes
			
			_this.update_hash($(this));

			if (!same_link) {
				$amenityMapList.scrollTop(0);


				_this.filter_categories();
				_this.categories.find('li').removeClass('am-categories--active');
				$(this).parent().addClass('am-categories--active');
			}

		});
	}

	update_hash($target){
		let currentPos = $(window).scrollTop();
		location.hash = '#' + $target.data('term-slug');
		$(window).scrollTop(currentPos);
	}

	/**
	 * Populate amenities with amenities that fit user selected category. 
	 */
	filter_categories() {

		this.amenities = this.localized_variables['data']['posts'];

		var amenities = [];
		
		if( this.category != 'all' ) {
		
			var category_amenities = this.localized_variables.accordion_categories;

			this.filteredAmenities = category_amenities.filter((amenityCategory) => amenityCategory.slug === this.category);
			amenities = this.filteredAmenities;
		}
		else {

			this.filteredAmenities = [];
			amenities = this.localized_variables['data']['posts'];
		}	

		if( 'list-view' == this.activeView ) {
			this.setListViewMarkup(amenities);
		}
		else {
			var allAmensFiltered = [];
			for(var c in amenities[0].childTerms) {
				var childTerm = amenities[0].childTerms[c];
				var childAmenities = childTerm.amenities;
				allAmensFiltered.concat(childAmenities);
				for( var a in childAmenities ) {
					allAmensFiltered.push( childAmenities[a] );
				}

			}

			if( this.category != 'all' ) {
				var amenitiesToMap = allAmensFiltered;
			}
			else {
				var amenitiesToMap = amenities;
			}

			this.build_amenity_map(amenitiesToMap);
		}

	}

	/**
	 * Build the amenity map by instantiating google map, adding markers to map, and initializing infobox
	 * 
	 */
	build_amenity_map(amenities) {

		const _this = this;
		let bounds = new google.maps.LatLngBounds();

		this.map_markers = [];
		// instantiate the map
		this.google_map = new google.maps.Map(document.getElementById("am-map"), this.settings.google_map_settings);
		
		if (this.infobox === null) {
			this.infobox = new InfoBox({
				content: $("#infobox"),
				pixelOffset: new google.maps.Size(-62, 27),
				zIndex: null,
				boxStyle: this.settings.infobox_settings,
				closeBoxMargin: "-4px -7px -5px 5px",
				closeBoxURL: this.localized_variables["theme_url"] + "/assets/img/close_lightbox.png"
			});
		}
		
		// add markers to map
		for (let amenity of amenities) {
			this.add_marker(amenity, bounds);
		}

		var boundsListener = google.maps.event.addListener((this.google_map), 'bounds_changed', function(event) {
			this.setZoom(16);
			google.maps.event.removeListener(boundsListener);
		});

	}

	/**
	 * Add amenity marker to map
	 * @param {[type]} amenity [description]
	 * @param {[type]} bounds  [description]
	 */
	add_marker(amenity, bounds) {
		
		if( !amenity || !amenity.amenity_latitude ) {
			return false;
		}

		let _this = this;
		
		let amenity_lat_lng = new google.maps.LatLng(amenity.amenity_latitude, amenity.amenity_longitude);
		bounds.extend(amenity_lat_lng);

		let icon = { 
				url: (amenity.term_icon === null ? 'http://www.loghillrun.net/images/icon2.png' : amenity.term_icon),
				 scaledSize: new google.maps.Size(20, 20)
		};

		let marker = new google.maps.Marker({
			position: amenity_lat_lng,
			map: this.google_map,
			zoom: 12,
			title: "Primary Location",
			icon: icon,
			amenity_id: amenity.ID
		});

		marker.setIcon(icon);

		// push marker to marker array
		this.map_markers.push(marker);

		google.maps.event.addListener(marker, 'click', function (marker) {
			return function () {

				// create active marker object and push it to active marker queue
				if (_this.is_infobox_open) {
					_this.deactivize_icon(_this.previous_marker);
					_this.infobox.close();	
				}
				_this.setActiveAmenity(marker.amenity_id);
				_this.active_marker.marker = marker;
				_this.active_marker.icon = icon;

				_this.is_infobox_open = true;

				_this.activize_icon(marker);

				_this.previous_marker = marker;

			};
		}(marker));

		google.maps.event.addListener(_this.infobox, 'closeclick', function (marker) {
			return function () {
				_this.is_infobox_open = false;
				_this.deactivize_icon(_this.previous_marker);
			};
		}(marker));

		this.google_map.fitBounds(bounds);
	}



	/**
	 * Get the place id using google services
	 * @param  {[type]} marker  [description]
	 * @param  {[type]} amenity [description]
	 */
	get_place(marker, amenity) {
		const _this = this;
		const place_id = amenity.place_id;
		const service = new google.maps.places.PlacesService(this.google_map);
		let html = "";

		service.getDetails({
			placeId: place_id
		}, (place, status) => {
			if (status === google.maps.places.PlacesServiceStatus.OK) {
				let extended_amenity = $.extend({}, amenity, place);
				let lat_lng = new google.maps.LatLng(amenity.amenity_latitude, amenity.amenity_longitude);

				html = _this.write_markup(extended_amenity);
				_this.infobox.setContent(html);
				_this.infobox.open(_this.google_map, marker);
				_this.google_map.panTo(lat_lng);
			}
		});
	}

	/**
	 * Make icon active state
	 * @param  {[type]} marker [description]
	 * @return {[type]}        [description]
	 */
	activize_icon(marker) {
		let icon = {
			url: this.settings.amenity_map_settings.active_icon,
			scaledSize: new google.maps.Size(30, 30)
		}
		marker.setIcon(icon);
	}

	deactivize_icon(marker) {
		let icon = {
			url: this.active_marker.icon.url,
			scaledSize: new google.maps.Size(30, 30)
		}
		marker.setIcon(icon);
	}

	/**
	 * Write up HTML given the place object
	 * @param  {[type]} place [description]
	 * @return {[type]}       [description]
	 */
	write_markup(place) {
		var html = '';

		var address = typeof place.adr_address !== "undefined" ? place.adr_address : '';
		var phone = typeof place.formatted_phone_number !== "undefined" ? place.formatted_phone_number : '';
		var website = typeof place.website !== "undefined" ? place.website : '';
		var opening_hours = typeof place.opening_hours !== "undefined" ? place.opening_hours.weekday_text : '';
		var hours_string = '';
		for (var i = 0; i < opening_hours.length; i++) hours_string += '<li>' + opening_hours[i] + '</li>';

		html += `<div class="infobox__inner">`;
		html +=	`<h3 class="infobox__title">${place.name}</h3>`;
		html +=	this.settings.info_display.address === "1" ? `<div class="infobox__address">${address}</div>` : '';
		html +=	this.settings.info_display.phone === "1" ? `<div class="infobox__phone"><a href="tel:${phone}">${phone}</a></div>` : '';
		html += this.settings.info_display.website === "1" ? `<div class="infobox__website"><a href="${website}" target="_blank">${website}</a></div>` : '';
		html += `<p class="infobox__link"><a class="google-map-link" href="${place.url}" target="_blank">View in Google Maps</a></p>`;
		html += '</div>';

		return html;
	}



	/*
	* Define our default settings, extend them with user defined settings, append them all to settings. 
	 */
	defaults(user_amenity_map_settings, user_map_settings, user_infobox_settings, user_callback) {
		// amenity map settings
		let default_amenity_map_settings = {'primary_location': null, 'icon': '', 'center': {'latitude': 43.6601, 'longitude': -79.4347}};
		let amenity_map_settings = $.extend({}, default_amenity_map_settings, user_amenity_map_settings);

		// google map settings
		let default_map_styles = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#a0d6d1"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#dedede"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#dedede"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f1f1f1"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}];
		let map_styles = user_map_settings.map_styles ? JSON.parse(user_map_settings.map_styles) : default_map_styles;

		var myLatLng = {lat: 43.6881, lng: -79.3941};

		let default_map_settings = {
			styles: map_styles,
			mapTypeId: 'roadmap',
			scrollwheel: false,
			zoomControl: true,
			center: myLatLng,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			scrollwheel: false,
			zoom: 10
		};
		let google_map_settings = $.extend({}, default_map_settings, user_map_settings.map_options );
		
		// infobox settings
		let default_infobox_settings = {
			opacity: 1,
			width: "auto",
			backgroundColor: "rgba(0, 0, 0, 0.9)",
			color: "#fff",
			padding: "24px 31px",
			borderRadius: "12px",
			fontSize: '12px'
		}
		let infobox_settings = $.extend({}, default_infobox_settings, user_infobox_settings.style);

		// now let's remove style. Note that Objects are immutable. So it's necessary that we cloned style into
		// infobox_settings before we deleted it. 
		delete user_infobox_settings.style;

		let callback = user_callback;

		this.settings = {
			'amenity_map_settings': amenity_map_settings, 
			'google_map_settings': google_map_settings, 
			'infobox_settings': infobox_settings, 
			'info_display': user_infobox_settings,
			'callback': callback
		};
	}

	resize() {
		this.viewport_width = $(window).width();
	}
}

module.exports = AmenityMap;